<!--  -->
<template>
<div class='container'>
    <div class="top">
        <i class="iconfont icon-sousuo1"></i>
        <input type="text" placeholder="查找企业">
    </div>
    <div class="list">
        <ul>
            <li class="all">全部</li>
            <li class="apply">已报名</li>
            <li class="no_apply">未报名</li>
            <li class="binding_apply">绑定申请</li>
        </ul>
    </div>
    <!-- <div class="student_list" v-for="(item,i) in allStudent" :key="i">
        <div class="first_name">{{item.chart}}</div>
        <div class="student">
            <div class="item" v-for="(res,index) in item.data" :key="index">
                <div class="left">
                    <img src="../../assets/image/Wechat.png" alt="">
                    <span class="name">{{res.realname}}</span>
                </div>
                <div class="right">
                    <span class="status">解除绑定</span>
                </div>
            </div>
        </div>
    </div> -->
    <!-- <div class="student_list">
        <div class="first_name">A</div>
        <div class="student">
            <div class="item">
                <div class="left">
                    <img src="../../assets/image/Wechat.png" alt="">
                    <span class="name">张三丰</span>
                </div>
                <div class="right">
                    <span class="status">解除绑定</span>
                </div>
            </div>
            <div class="item">
                <div class="left">
                    <img src="../../assets/image/Wechat.png" alt="">
                    <span class="name">张三丰</span>
                </div>
                <div class="right">
                    <span class="status">解除绑定</span>
                </div>
            </div>
            <div class="item">
                <div class="left">
                    <img src="../../assets/image/Wechat.png" alt="">
                    <span class="name">张三丰</span>
                </div>
                <div class="right">
                    <span class="status">解除绑定</span>
                </div>
            </div>
        </div>
    </div> -->
    <div class="char-list-border">
        <ul
          class="char-list"
          ref="charBar"
          @touchstart="e => touchStart(e)"
          @touchmove="e => touchMove(e)"
          @touchend="e => touchEnd(e)"
        >
          <li
            class="char-item"
            v-for="(char,index) in charList"
            :key="index"
          >{{char}}</li>
        </ul>
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    charList: {0:'A',1:'B'},
    allStudent:[]
};
},
//监听属性 类似于data概念
computed: {

},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    // this.getBindStudent(0)
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    position: relative;
    .top{
        width: 100%;
        height: 51px;
        background-color: #fff;
        position: relative;
        padding-bottom: 5px;
        input{
            width: 90%;
            background-color: #f0f0f0;
            text-align: center;
            color: #999999;
            font-size: 14px;
            border: none;
            height: 34px;
            line-height: 34px;
            border-radius: 17px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        .iconfont{
            position: absolute;
            top: 50%;
            left: 40%;
            transform: translate(-50%,-50%);
            z-index: 10;
            color:#999999;
        }
    }
    .list{
        width: 100%;
        height: 40px;
        ul{
            width: 100%;
            height: 40px;
            background-color: #fff;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
            padding: 10px 0;
            box-sizing: border-box;
            li{
                width: 24%;
                height: 100%;
                float: left;
                font-size: 17px;
                color: #666666;
                line-height: 20px;
                text-align: center;
                border-right: 1px solid #ddd;
            }
        }
    }
    .student_list{
        width: 100%;
        background-color: #fff;
        .first_name{
            font-size: 21px;
            color: #666666;
            width: 100%;
            height: 28px;
            line-height: 28px;
            background-color: #f5f5f5;
            padding-left: 23px;
            box-sizing: border-box;
        }
        .student{
            width: 100%;
            .item{
                width: 100%;
                padding: 5px 25px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #ddd;
                .left{
                    img{
                    width: 55px;
                    height: 55px;
                    vertical-align: middle;
                }
                .name{
                    font-size: 24px;
                    color: #333333;
                    vertical-align: middle;
                    margin-left: 16px;
                }
                }
                .right{
                    .status{
                    font-size: 19px;
                    color: #63B0F7;
                    margin-right: 20px;
                }
                }
                
            }
        }
    }
    .char-list-border {
    padding-top: 150px;
    position: fixed;
    right: 0;
    top: 0;
    width: 20px;
    height: 30px;
    margin: 0;
    box-sizing: border-box;
  }
  .char-list {
    list-style-type: none;
    padding-left: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    height: 20px;
    box-sizing: border-box;
  }
  .char-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>